import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnChanges,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { StoryblokReplaceService } from '../../../services/storyblok-replace.service';
import { ResizeDirective } from '../../../shared/directives/resize.directive';
import { StoryblokDirective } from '../../storyblok.directive';

export interface BlockStyle {
  background: 'inherit' | 'white' | 'dark' | 'black' | 'white-no-bg' | 'dark-no-bg';
  topSpacing: string;
  bottomSpacing: string;
  mobileTopSpacing?: string;
  mobileBottomSpacing?: string;
  pageWidth: string;
  customPageWidth?: number;
  customPageWidthMobile?: number;
  noHorizontalPadding?: boolean;
  hideOnMobile?: boolean;
  hideOnTablet?: boolean;
  hideOnDesktop?: boolean;
  inWrapper?: boolean;
  alignLeftChildPages?: boolean;
  bottomBorder?: string;
  customTemplateCondition?: string;
  fullHeight?: boolean;
}

export const getPageWidth = (pageWidth: string, customWidth: number) => {
  if (pageWidth === '0') {
    return 580;
  }
  if (pageWidth === '0-5') {
    return 680;
  }
  if (pageWidth === '1') {
    return 780;
  }
  if (pageWidth === '2') {
    return 880;
  }
  if (pageWidth === '3') {
    return 980;
  }
  if (pageWidth === 'default' || !pageWidth) {
    return 1180;
  }
  if (pageWidth === '4') {
    return 1380;
  }
  if (pageWidth === 'custom') {
    return customWidth;
  }
};

@Component({
  selector: 'app-block-wrapper',
  standalone: true,
  imports: [StoryblokDirective, ResizeDirective],
  templateUrl: './block-wrapper.component.html',
  styleUrls: ['./block-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BlockWrapperComponent implements OnChanges {
  private storyblokReplaceService = inject(StoryblokReplaceService);
  private check = inject(ChangeDetectorRef);
  @HostBinding('class') class = 'section';
  @Input() _editable: string;
  @Input() otherClasses: string;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('style') _style: BlockStyle[];
  style: BlockStyle;
  screens: string[] = ['mobile', 'tablet', 'desktop'];
  pageWidth: number;
  customHidden: boolean;

  ngOnChanges(): void {
    this.style = this._style?.[0] || {
      background: 'inherit',
      topSpacing: undefined,
      bottomSpacing: undefined,
      pageWidth: undefined,
    };

    if (!this.style.topSpacing) this.style.topSpacing = '4';
    if (!this.style.bottomSpacing) this.style.bottomSpacing = '4';
    if (!this.style.pageWidth) this.style.pageWidth = 'default';

    this.class = 'section';
    this.class += ` ${this.style.background}`;
    if (this.style.background === 'black') {
      this.class += ' dark';
    }
    if (this.style.background === 'dark-no-bg') {
      this.class += ' dark';
    }
    if (this.style.background === 'white-no-bg') {
      this.class += ' white';
    }

    if (this.style.noHorizontalPadding || this.style.inWrapper) {
      this.class += ' no-horizontal-padding';
    }

    if (this.style.bottomBorder) {
      this.class += ` bottom-border-${this.style.bottomBorder}`;
    }

    if (this.style.fullHeight) {
      this.class += ' full-height';
    }

    this.pageWidth = getPageWidth(this.style.pageWidth, this.style.customPageWidth);

    this.screens = [];
    if (!this.style.hideOnMobile) this.screens.push('mobile');
    if (!this.style.hideOnTablet) this.screens.push('tablet');
    if (!this.style.hideOnDesktop) this.screens.push('desktop');

    this.customHidden =
      this.style.customTemplateCondition &&
      !this.storyblokReplaceService.getFromKey(this.style.customTemplateCondition);

    this.check.markForCheck();
  }
}
